// extracted by mini-css-extract-plugin
export default {"logo":"notfound_logo__v3q7W","message":"notfound_message__1TTxd","App-logo-spin":"notfound_App-logo-spin__I7CWF"};